import { render, staticRenderFns } from "./StPrivateOrderForm.vue?vue&type=template&id=ab430566"
import script from "./StPrivateOrderForm.vue?vue&type=script&lang=ts"
export * from "./StPrivateOrderForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports